module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Movie-Lane2-d1b6e3fde40e3f88a166cb468f8707dc.svg";